import { createAsyncAction } from 'typesafe-actions';
import { ChangePasswordDto } from './changePassword.dtos';

export const changePasswordActions = createAsyncAction(
  'CHANGE_PASSWORD_REQUEST',
  'CHANGE_PASSWORD_SUCCESS',
  'CHANGE_PASSWORD_ERROR',
)<ChangePasswordDto, string, string>();